import React, { useEffect, useContext, useState } from "react";
import { useSelector } from "react-redux";

import Button from "components/UI/Button";
import { useIntlHelper } from "hooks";
import { ReactIf } from "components/common/ReactIf";
import {
  useGetDashboardInfoMutation,
  useGetDashboardTokenMutation,
} from "services/dashboard";
import {
  errorTrash,
  bluePencil,
  arrowBlueRight,
  close,
  arrowBlueLeft,
} from "assets/icons";
import { selectDashboardData } from "@redux/reducers/dashboardInfo";

import {
  foundationNames,
  priceOptimizationNames,
  inventoryOptimizationNames,
} from "../../../../utils/utilsDashboard";
import ClientContext from "../Context";
import Context from "../Context";
import useManageExternalLink from "../ManageExternalLink";
import useRemoveDashboard from "./useRemoveDashboard";
import useRemoveDashParentItemMenu from "./useRemoveDashParentItemMenu";
import MockedLayout from "./MockedLayout";
import MockedLayoutNew from "./MockedLayoutNew";
import MockedLayoutSubMenusNames from "./MockedLayoutSubMenusNames";
import Skeleton from "./Skeleton";
import { filterName } from "../../../../utils/utils";

import "./styles.scss";

type ParentMenu = {
  id: number;
  label: string;
  new: boolean;
};

type SubItemMenu = {
  id: number;
  label: string;
  new: boolean;
};

export const DashboardContentWithOutDashboardWrapper: React.FC = () => {
  const { data: dashboardData = {} }: any = useSelector(selectDashboardData);

  const { parentMenu, step, setStep } = useContext(ClientContext);

  const { getIntlMessage } = useIntlHelper();
  const {
    isEditMode,
    isUserDataLoaded,
    companyId,
    dashboardId,
    newParentName,
    setNewParentName,
    setNewSubItemMenuName,
    setNewIconArry,
  } = useContext(Context);
  const [fetchDashboardInfo]: any = useGetDashboardInfoMutation();
  const [fetchDashboardToken, { data: authTokenData }]: any =
    useGetDashboardTokenMutation();
  const manageExternalLink = useManageExternalLink();

  const [parentMenuName, setParentMenuName] = useState<
    ParentMenu | string | null
  >(null);
  const [subMenuName, setSubMenuName] = useState<SubItemMenu | string | null>(
    null
  );

  const removeDashboard = useRemoveDashboard();
  const removeDashParentItemMenu = useRemoveDashParentItemMenu();

  const menuItems = parentMenu.map((menu) => ({
    id: Number(menu.id),
    label: menu.name,
    new: false,
  }));

  const showNewDashboard = () => {};

  const stepBack = () => {
    switch (step) {
      case 1:
        setParentMenuName(null);
        setStep(step - 1);
        break;
      case 2:
        setSubMenuName(null);
        setStep(step - 1);
        break;
      default:
        setParentMenuName(null);
        setSubMenuName(null);
    }
  };

  useEffect(
    () => {
      if (isUserDataLoaded) {
        setTimeout(() => {
          //make a request here
          fetchDashboardToken(companyId);
        }, 500);
      }
    },
    // eslint-disable-next-line
    [isUserDataLoaded, dashboardId]
  );

  console.log("isUserDataLoaded: ", isUserDataLoaded);
  console.log("dashboardId: ", dashboardId);
  console.log("companyId: ", companyId);
  console.log("authTokenData: ", authTokenData);

  const renderSteps = () => {
    switch (step) {
      case 0:
        setNewIconArry("[trendingUpBlack, trendingUp]");
        return (
          <MockedLayoutNew
            menuItems={menuItems}
            setParentMenuName={setParentMenuName}
            setNewParentName={setNewParentName}
            setStep={setStep}
          />
        );
      case 1:
        return (
          <MockedLayoutSubMenusNames
            menuItems={menuItems}
            newParentName={newParentName}
            setSubMenuName={setSubMenuName}
            setNewSubItemMenuName={setNewSubItemMenuName}
            setStep={setStep}
          />
        );
      case 2:
        return <MockedLayout />;
      default:
        return (
          <div className="widget_base-info">
            <Skeleton />
          </div>
        );
    }
  };

  if (!authTokenData?.auth_token) {
    return (
      <div className="widget_base-info">
        <Skeleton />
      </div>
    );
  }

  if (authTokenData?.auth_token && isEditMode) {
    return (
      <section className="dashboard-content">
        <div className="widget_base-info">
          {step == 0 && (
            <h3 className="dashboard-title">
              {getIntlMessage("create_or_select_a_parent_menu")}
            </h3>
          )}
          {(step == 1 || step == 2) && (
            <h3 className="dashboard-title">
              {getIntlMessage("parent_menu") + ": " + parentMenuName}
            </h3>
          )}
          {step != 0 && (
            <ReactIf value={isEditMode}>
              <div className="dashboard-actions">
                <Button
                  startIcon={<img src={arrowBlueLeft} alt="back" />}
                  variant="text"
                  onClick={stepBack}
                >
                  {getIntlMessage("back")}
                </Button>
              </div>
            </ReactIf>
          )}
        </div>

        {step == 2 && (
          <div className="widget_base-info">
            <h3 className="dashboard-sub-title">
              {getIntlMessage("dashboard_name") +
                ": " +
                filterName(subMenuName)}
            </h3>
          </div>
        )}

        {renderSteps()}
      </section>
    );
  }

  return <div></div>;
};

export const DashboardContentWithOutDashboard = () => {
  return (
    <>
      {/* eslint-disable-next-line */}
      <iframe
        id="logout-from-helico"
        src={`${process.env.REACT_APP_THIRD_PARTY_URL}/hi-ee/j_spring_security_logout`}
        width="0px"
        height="0px"
      ></iframe>
      <DashboardContentWithOutDashboardWrapper />
    </>
  );
};
